import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Oneseaterurbaniaonrentinshirdi() {



    const cardData = {





keyword: "17 Seater Urbania on Rent in Shirdi",
headingDescription: "Sai Shirdi Cab offers 17 Seater Urbania on Rent in Shirdi for families, friends, corporate groups, pilgrimage groups, wedding functions, school or college groups, and travelers planning comfortable group transportation. A 17 seater Urbania is an excellent option for passengers who want to travel together in one spacious vehicle instead of booking multiple cars. Our Urbania rental service is available for Shirdi local travel, airport transfers, sightseeing, religious tours, one-way outstation journeys, round trips, and multi-day road trips. The vehicle provides comfortable seating and useful luggage space, making it suitable for both short-distance transfers and longer journeys from Shirdi. Sai Shirdi Cab can arrange the 17 seater Urbania according to your preferred travel date, pickup location, destination, trip duration, and group requirements. Whether you are planning a family vacation, pilgrimage tour, corporate outing, wedding transportation, or multi-city road trip, our 17 seater Urbania rental service offers a convenient and organized travel solution.",
topPlaces: [
{
title: "Goa",
description: "Goa is a great destination for a group holiday from Shirdi, especially for families and friends traveling together for several days. A 17 seater Urbania provides a practical travel solution by keeping the entire group in one vehicle while offering comfortable seating and convenient luggage arrangements. Sai Shirdi Cab can arrange the Urbania for a customized Shirdi to Goa itinerary, including flexible departure timing, planned travel breaks, sightseeing stops, hotel transfers, and return transportation according to the group's schedule."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar is a popular choice for families and groups looking for a refreshing hill-station trip from Shirdi. The 17 seater Urbania is suitable for group travel because passengers can remain together while exploring viewpoints, markets, scenic locations, and nearby attractions. Sai Shirdi Cab provides Urbania rental for customized Mahabaleshwar trips with comfortable group transportation, luggage space, flexible pickup arrangements, and options for one-day, round-trip, or multi-day sightseeing plans."
},
{
title: "Pune",
description: "Pune is an important outstation destination from Shirdi for corporate travel, family functions, educational trips, airport transfers, and personal visits. A 17 seater Urbania makes group transportation easier by avoiding the need to coordinate multiple small vehicles. Sai Shirdi Cab can arrange a dedicated Urbania from Shirdi to Pune with suitable pickup and drop-off points, comfortable travel, professional driving, luggage arrangements, and flexible one-way or return-trip options."
},
{
title: "Mumbai",
description: "Mumbai is suitable for larger groups traveling from Shirdi for business meetings, family occasions, events, airport connections, and leisure activities. A 17 seater Urbania offers the convenience of traveling together while providing more passenger and luggage space than regular cars. Sai Shirdi Cab can customize the Shirdi to Mumbai Urbania booking according to the group's travel schedule, preferred pickup location, luggage requirements, and whether the journey is one-way, round-trip, or part of a longer itinerary."
},
{
title: "Bhimashankar",
description: "Bhimashankar is an ideal destination for pilgrimage groups and families planning a religious journey from Shirdi. A 17 seater Urbania is particularly useful when several passengers want to visit the temple and surrounding areas together without arranging separate transportation. Sai Shirdi Cab can provide a dedicated Urbania with flexible departure timing, comfortable seating, luggage capacity, and customized options for combining Bhimashankar with other religious or sightseeing destinations."
},
{
title: "Ujjain",
description: "Ujjain can be included in a longer pilgrimage tour from Shirdi for groups visiting important religious destinations across Madhya Pradesh. The spacious 17 seater Urbania allows families and pilgrimage groups to travel together during the extended road journey while keeping luggage organized. Sai Shirdi Cab can customize the Urbania rental for a Shirdi to Ujjain trip with suitable travel breaks, overnight arrangements, additional pilgrimage stops, sightseeing requirements, and return or onward travel."
},
{
title: "Chhatrapati Sambhajinagar",
description: "Chhatrapati Sambhajinagar, formerly known as Aurangabad, is a suitable destination for groups interested in historical monuments, caves, temples, and heritage attractions. A 17 seater Urbania is convenient for groups that want to cover multiple locations without changing vehicles during the trip. Sai Shirdi Cab can arrange a customized Urbania journey from Shirdi covering Chhatrapati Sambhajinagar and nearby attractions such as Ellora, Ajanta, and Grishneshwar according to the group's itinerary."
},
{
title: "Nashik",
description: "Nashik is a convenient outstation destination for groups traveling from Shirdi for religious visits, family functions, business requirements, and sightseeing. Renting a 17 seater Urbania allows larger groups to travel together with comfortable seating and sufficient space for luggage. Sai Shirdi Cab can organize the journey from Shirdi to Nashik with flexible pickup and drop-off arrangements, convenient travel breaks, and options to extend the trip toward Trimbakeshwar or other nearby destinations."
},
{
title: "Ahmednagar",
description: "Ahmednagar is useful for group travel from Shirdi for family visits, business purposes, religious journeys, and regional sightseeing. A 17 seater Urbania provides an efficient option for groups that want one dedicated vehicle instead of splitting passengers across multiple cabs. Sai Shirdi Cab can arrange Urbania rental according to the passenger count, travel date, pickup location, journey duration, and return requirements, making the trip easier to coordinate from start to finish."
},
{
title: "Trimbakeshwar",
description: "Trimbakeshwar is a valuable addition to a religious itinerary from Shirdi and is well suited for families and pilgrimage groups traveling together. A 17 seater Urbania provides comfortable group transportation and allows passengers to carry their luggage conveniently throughout the journey. Sai Shirdi Cab can arrange the Urbania for a dedicated Shirdi to Trimbakeshwar trip or create a broader pilgrimage itinerary that includes Nashik and other nearby destinations."
}
]
,







"services": [
{
"name": "17 Seater Urbania on Rent in Shirdi",
"description": "17 Seater Urbania on Rent in Shirdi is a spacious travel option for families, tour groups, corporate teams, and pilgrims who want to travel together comfortably. Sai Shirdi Cabs provides well-maintained Urbania vehicles with professional drivers for local sightseeing, airport transfers, and outstation journeys."
},
{
"name": "17 Seater Force Urbania Rental Shirdi",
"description": "17 Seater Force Urbania Rental Shirdi offers convenient group transportation with comfortable seating and sufficient luggage space. Sai Shirdi Cabs provides private Urbania rentals for family trips, corporate travel, pilgrimage tours, weddings, sightseeing, and customized outstation routes."
},
{
"name": "17 Seater Urbania Hire in Shirdi",
"description": "17 Seater Urbania Hire in Shirdi is suitable for larger groups looking for a dedicated vehicle instead of using multiple cars. Sai Shirdi Cabs offers flexible Urbania hire with experienced drivers for local travel, religious tours, events, airport transfers, and long-distance journeys."
},
{
"name": "17 Seater Urbania Booking Shirdi",
"description": "17 Seater Urbania Booking Shirdi makes it easy to reserve a spacious vehicle for planned group travel. Sai Shirdi Cabs provides advance booking options for pilgrimage tours, family holidays, corporate trips, weddings, sightseeing programs, and outstation transportation."
},
{
"name": "17 Seater Urbania with Driver Shirdi",
"description": "17 Seater Urbania with Driver Shirdi provides a comfortable chauffeur-driven travel experience for groups of up to 17 passengers. Sai Shirdi Cabs offers professional drivers along with spacious Urbania vehicles for local sightseeing, airport journeys, pilgrimage trips, and outstation travel."
},
{
"name": "17 Seater Urbania Cab Shirdi",
"description": "17 Seater Urbania Cab Shirdi is a practical choice for families and groups who want private transportation around Shirdi and beyond. Sai Shirdi Cabs provides spacious cab service for hotel transfers, sightseeing, pilgrimage visits, airport transportation, and customized journeys."
},
{
"name": "17 Seater Urbania Taxi Shirdi",
"description": "17 Seater Urbania Taxi Shirdi offers group-friendly transportation with comfortable seating for family, business, and tour requirements. Sai Shirdi Cabs arranges private Urbania taxi service with professional drivers for local destinations and outstation routes from Shirdi."
},
{
"name": "17 Seater Urbania for Outstation Shirdi",
"description": "17 Seater Urbania for Outstation Shirdi is ideal for larger groups planning a comfortable road journey from Shirdi to another city. Sai Shirdi Cabs provides private Urbania transportation for one-way and round-trip travel with ample passenger and luggage capacity."
},
{
"name": "17 Seater Urbania for Family Trip Shirdi",
"description": "17 Seater Urbania for Family Trip Shirdi provides families with a convenient way to travel together in one spacious vehicle. Sai Shirdi Cabs offers comfortable Urbania service for family holidays, temple visits, sightseeing, weekend trips, and longer outstation journeys."
},
{
"name": "17 Seater Urbania for Wedding Shirdi",
"description": "17 Seater Urbania for Wedding Shirdi is suitable for transporting relatives, guests, and family members between hotels, venues, and travel destinations. Sai Shirdi Cabs provides spacious and professionally driven Urbania vehicles for wedding transportation and related group travel requirements."
},
{
"name": "17 Seater Urbania for Corporate Trip Shirdi",
"description": "17 Seater Urbania for Corporate Trip Shirdi offers organized group transportation for employees, business teams, and corporate visitors. Sai Shirdi Cabs provides private Urbania service for meetings, corporate outings, airport transfers, conferences, and outstation business travel."
},
{
"name": "17 Seater Urbania for Pilgrimage Shirdi",
"description": "17 Seater Urbania for Pilgrimage Shirdi is designed for devotees traveling together to Shirdi and nearby religious destinations. Sai Shirdi Cabs offers spacious Urbania transportation for temple visits, multi-destination pilgrimage tours, and comfortable group travel."
},
{
"name": "17 Seater Urbania for Tour Shirdi",
"description": "17 Seater Urbania for Tour Shirdi provides a convenient group vehicle for sightseeing and multi-destination travel. Sai Shirdi Cabs offers private Urbania service for families, tourists, and organized groups visiting Shirdi, nearby attractions, and outstation destinations."
},
{
"name": "17 Seater Urbania One Way Shirdi",
"description": "17 Seater Urbania One Way Shirdi is a convenient option for groups that need direct transportation without booking a return journey. Sai Shirdi Cabs provides one-way Urbania travel from Shirdi to airports, cities, pilgrimage destinations, tourist locations, and other requested routes."
},
{
"name": "17 Seater Urbania Round Trip Shirdi",
"description": "17 Seater Urbania Round Trip Shirdi is suitable for groups planning return travel after completing their destination visit. Sai Shirdi Cabs offers dedicated Urbania vehicles for family tours, pilgrimage programs, sightseeing trips, corporate journeys, and multi-day travel."
},
{
"name": "17 Seater Urbania Airport Pickup Shirdi",
"description": "17 Seater Urbania Airport Pickup Shirdi provides spacious transportation for groups arriving at Shirdi Airport. Sai Shirdi Cabs can arrange private Urbania pickup for families, tour groups, corporate travelers, and pilgrims with comfortable onward transfers to hotels or other destinations."
},
{
"name": "17 Seater Urbania Railway Station Shirdi",
"description": "17 Seater Urbania Railway Station Shirdi is useful for groups arriving by train and requiring comfortable transportation to hotels or other destinations. Sai Shirdi Cabs provides private Urbania pickup and drop services around Shirdi Railway Station along with local and outstation travel."
},
{
"name": "17 Seater Urbania Sightseeing Shirdi",
"description": "17 Seater Urbania Sightseeing Shirdi offers a convenient way for larger groups to explore Shirdi and nearby attractions together. Sai Shirdi Cabs provides spacious vehicles with professional drivers for temple visits, local sightseeing, family tours, and customized sightseeing schedules."
},
{
"name": "Affordable 17 Seater Urbania Rental Shirdi",
"description": "Affordable 17 Seater Urbania Rental Shirdi provides a cost-conscious group transportation solution without requiring passengers to split across multiple vehicles. Sai Shirdi Cabs offers Urbania rentals for family travel, pilgrimage tours, sightseeing, airport transfers, and outstation journeys."
},
{
"name": "Best 17 Seater Urbania Hire Shirdi",
"description": "Best 17 Seater Urbania Hire Shirdi is a suitable choice for groups seeking spacious, private, and professionally driven transportation. Sai Shirdi Cabs provides Urbania hire for local trips, airport transfers, pilgrimage journeys, corporate travel, family tours, and outstation routes."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs provides 17 Seater Urbania rental and hire services in Shirdi for families, corporate groups, pilgrims, tourists, and larger travel parties. With spacious vehicles and professional drivers, customers can arrange airport transfers, railway station pickups, sightseeing, one-way trips, round trips, weddings, and outstation journeys."
}
],
"tableData": [
["17 Seater Urbania on Rent in Shirdi", "17 Seater Force Urbania Rental Shirdi"],
["17 Seater Urbania Hire in Shirdi", "17 Seater Urbania Booking Shirdi"],
["17 Seater Urbania with Driver Shirdi", "17 Seater Urbania Cab Shirdi"],
["17 Seater Urbania Taxi Shirdi", "17 Seater Urbania for Outstation Shirdi"],
["17 Seater Urbania for Family Trip Shirdi", "17 Seater Urbania for Wedding Shirdi"],
["17 Seater Urbania for Corporate Trip Shirdi", "17 Seater Urbania for Pilgrimage Shirdi"],
["17 Seater Urbania for Tour Shirdi", "17 Seater Urbania One Way Shirdi"],
["17 Seater Urbania Round Trip Shirdi", "17 Seater Urbania Airport Pickup Shirdi"],
["17 Seater Urbania Railway Station Shirdi", "17 Seater Urbania Sightseeing Shirdi"],
["Affordable 17 Seater Urbania Rental Shirdi", "Best 17 Seater Urbania Hire Shirdi"],
["Sai Shirdi Cabs", "17 Seater Urbania on Rent in Shirdi"]
]
,





whychoose: [  
 
    {   
 
        WhyChooseheading: "17 Seater Urbania on Rent in Shirdi for Group Travel",   
 
        WhyChoosedescription: "Sai Shirdi Cabs provides 17 Seater Urbania on Rent in Shirdi for families, pilgrimage groups, tourists, corporate teams, wedding guests, and other groups looking for convenient group transportation. A 17 Seater Urbania can be arranged for Sai Baba Darshan, Shirdi sightseeing, airport and railway station transfers, outstation journeys, religious tours, events, and multi-day travel."   
 
    },   
 
    {   
 
        WhyChooseheading: "Spacious 17 Seater Urbania Rental in Shirdi",   
 
        WhyChoosedescription: "Groups travelling together can choose a 17 Seater Urbania when they want to stay together in one dedicated vehicle. Sai Shirdi Cabs can organize the rental according to your passenger count, travel date, pickup location, destination, luggage requirements, preferred departure time, and overall journey schedule."   
 
    },   
 
    {   
 
        WhyChooseheading: "17 Seater Urbania for Sai Baba Darshan",   
 
        WhyChoosedescription: "Devotee groups visiting Shirdi can arrange a 17 Seater Urbania for Sai Baba Darshan and other pilgrimage transportation needs. The vehicle can be used for hotel transfers, temple visits, railway station transportation, local movement, and selected sightseeing locations while keeping the complete group together."   
 
    },   
 
    {   
 
        WhyChooseheading: "17 Seater Urbania for Shirdi Sightseeing",   
 
        WhyChoosedescription: "Tourists and family groups can rent a 17 Seater Urbania for exploring Shirdi and nearby attractions. The sightseeing journey can be planned around your selected locations, pickup and drop points, travel timings, passenger requirements, luggage, and preferred duration for a convenient group outing."   
 
    },   
 
    {   
 
        WhyChooseheading: "17 Seater Urbania for Outstation Trips from Shirdi",   
 
        WhyChoosedescription: "Sai Shirdi Cabs offers 17 Seater Urbania rental arrangements for groups travelling from Shirdi to nearby cities, pilgrimage destinations, tourist places, and other outstation locations. One-way, round-trip, and multi-day journeys can be discussed according to the destination, travel dates, passenger count, luggage, and planned itinerary."   
 
    },   
 
    {   
 
        WhyChooseheading: "Urbania for Family and Corporate Group Journeys",   
 
        WhyChoosedescription: "Families, corporate teams, school groups, college groups, and social organizations can arrange a 17 Seater Urbania in Shirdi for planned group transportation. Travelling in one vehicle can simplify coordination for luggage, meal breaks, sightseeing stops, hotel transfers, business visits, and other scheduled travel requirements."   
 
    },   
 
    {   
 
        WhyChooseheading: "17 Seater Urbania for Airport and Railway Transfers",   
 
        WhyChoosedescription: "Groups arriving at or departing from Shirdi Airport and railway station can use a 17 Seater Urbania for coordinated transfers. Sai Shirdi Cabs can plan pickup or drop transportation according to the passenger count, luggage requirements, travel schedule, location details, and onward journey arrangements."   
 
    },   
 
    {   
 
        WhyChooseheading: "Book 17 Seater Urbania on Rent in Shirdi",   
 
        WhyChoosedescription: "To book a 17 Seater Urbania on Rent in Shirdi, contact Sai Shirdi Cabs with your pickup location, travel date, passenger count, destination, luggage details, journey type, and preferred departure time. Complete trip information helps in arranging suitable Urbania transportation for local travel, pilgrimage visits, sightseeing, airport transfers, or outstation journeys."   
 
    }   
 
]   
 
 
}; 
 
const faqData = [ 
 
{ 
 
question: "Can I rent a 17 Seater Urbania in Shirdi?", 
 
answer: "Yes, Sai Shirdi Cabs provides 17 Seater Urbania rental services in Shirdi for families, tourists, pilgrimage groups, corporate teams, and other groups travelling together." 
 
}, 
 
{ 
 
question: "What can I use a 17 Seater Urbania in Shirdi for?", 
 
answer: "A 17 Seater Urbania can be arranged for Sai Baba Darshan, Shirdi sightseeing, family trips, corporate travel, airport transfers, railway station transfers, religious tours, events, and outstation journeys." 
 
}, 
 
{ 
 
question: "Is 17 Seater Urbania available for Shirdi sightseeing?", 
 
answer: "Yes, you can arrange a 17 Seater Urbania for Shirdi local sightseeing and nearby attractions according to your selected places, passenger requirements, travel schedule, and pickup and drop details." 
 
}, 
 
{ 
 
question: "Can I book a 17 Seater Urbania from Shirdi for an outstation trip?", 
 
answer: "Yes, a 17 Seater Urbania can be arranged from Shirdi for outstation destinations, including one-way, round-trip, and multi-day journeys based on your destination, travel dates, passenger count, and itinerary." 
 
}, 
 
{ 
 
question: "Is a 17 Seater Urbania suitable for family travel?", 
 
answer: "Yes, families can rent a 17 Seater Urbania for pilgrimage visits, sightseeing, family functions, airport transfers, railway station transfers, and long-distance road trips from Shirdi." 
 
}, 
 
{ 
 
question: "Can I use a 17 Seater Urbania for Sai Baba Darshan?", 
 
answer: "Yes, groups visiting Shirdi for Sai Baba Darshan can arrange a 17 Seater Urbania for transportation between their pickup location, hotel, temple area, railway station, and other planned destinations." 
 
}, 
 
{ 
 
question: "Can I book a 17 Seater Urbania for airport transfers?", 
 
answer: "Yes, a 17 Seater Urbania can be arranged for Shirdi Airport pickup and drop services based on your arrival or departure schedule, passenger count, luggage requirements, pickup location, and destination." 
 
}, 
 
{ 
 
question: "Can I travel with luggage in a 17 Seater Urbania?", 
 
answer: "Yes, passengers can travel with luggage, and providing the approximate luggage requirements along with the passenger count helps in planning the appropriate vehicle arrangement." 
 
}, 
 
{ 
 
question: "Can I book a 17 Seater Urbania for a multi-day trip?", 
 
answer: "Yes, multi-day Urbania travel can be discussed for pilgrimage tours, family vacations, sightseeing journeys, group events, and multi-destination road trips according to your planned itinerary." 
 
}, 
 
{ 
 
question: "How can I book a 17 Seater Urbania on Rent in Shirdi?", 
 
answer: "You can contact Sai Shirdi Cabs with your travel date, pickup location, passenger count, destination, luggage information, preferred departure time, and journey type to arrange a 17 Seater Urbania rental service." 
 
} 
 
]; 
 
const testimonials = [ 
 
{ 
 
id: 1, 
 
name: "Mr. Rahul Desai", 
 
feedback: "Our pilgrimage group had several members travelling together, so having one 17 Seater Urbania made the transportation much easier to coordinate. We could manage our Darshan schedule, hotel transfers, luggage, and local sightseeing without arranging separate cars.", 
 
rating: 5 
 
}, 
 
{ 
 
id: 2, 
 
name: "Mrs. Sneha Patil", 
 
feedback: "During our family visit to Shirdi, the private Urbania was a convenient choice for moving everyone together. The travel arrangement worked well for our sightseeing plans, pickup and drop requirements, and the different stops we wanted to cover during the trip.", 
 
rating: 5 
 
} 
 
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "17 Seater Urbania on Rent in Shirdi",
  "image": "https://www.saishirdicabs.com/assets/images/17-seater-urbania-on-rent-in-shirdi.webp",
  "description":
    "Book a 17 Seater Urbania on Rent in Shirdi with Sai Shirdi Cabs for comfortable, spacious, and reliable group travel. Our 17 Seater Force Urbania is suitable for Sai Baba Darshan, Shirdi sightseeing, family trips, group tours, weddings, corporate travel, pilgrimage journeys, airport transfers, railway station transfers, one-way journeys, round trips, and outstation travel. Get a well-maintained Urbania with a professional driver, convenient pickup and drop locations, affordable rental service, and easy booking assistance.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/17-seater-urbania-on-rent-in-shirdi"
  }
};





    return (
        <div>

<Helmet>
  <title>17 Seater Urbania on Rent in Shirdi | Urbania Rental | +91 7776814559</title>

  <meta
    name="description"
    content="Book a 17 Seater Urbania on Rent in Shirdi with Sai Shirdi Cabs for group travel, Sai Baba Darshan, sightseeing, family trips, weddings and outstation journeys. Get a spacious Urbania with professional driver and easy booking."
  />

  <meta
    name="keywords"
    content="17 Seater Urbania on Rent in Shirdi, 17 Seater Force Urbania Rental Shirdi, 17 Seater Urbania Hire in Shirdi, 17 Seater Urbania Booking Shirdi, 17 Seater Urbania with Driver Shirdi, 17 Seater Urbania Cab Shirdi, 17 Seater Urbania Taxi Shirdi, 17 Seater Urbania for Outstation Shirdi, 17 Seater Urbania for Family Trip Shirdi, 17 Seater Urbania for Wedding Shirdi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/116.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Oneseaterurbaniaonrentinshirdi;